import type { OptionsDocument, AnyPresentationOption } from 'paintscout'
import shuffle from 'lodash/shuffle'
import { getPrefabImages } from '../../../../database/fixtures/presentations/prefabImages'

/**
 * The pool of placeholder images a newly added block/section is filled from. Presentations made
 * in NewPresentationDialog persist `advanced.defaultImages`; AI-generated and v1→v2 converted ones
 * may not, so fall back to the prefab stock photos rather than an empty pool — an empty pool
 * leaves image blocks with no `src` (#24160).
 */
export function getDefaultPresentationImages(args: { options: OptionsDocument; presentation: AnyPresentationOption }) {
  const { presentation } = args

  if (presentation.advanced?.defaultImages && presentation.advanced.defaultImages.length > 0) {
    return shuffle(presentation.advanced.defaultImages)
  }

  return getPrefabImages() // already shuffled
}
